// extracted by mini-css-extract-plugin
export default {"main":"Condiciones_main__R7lrI","imagen":"Condiciones_imagen__rxIB8","title":"Condiciones_title__JZyTe","accordion":"Condiciones_accordion__ul+2n"};